import { Grid, Typography } from '@mui/material';
import LabelValue from '../LabelValue';
import { selectBaseLanguages, selectSubtitlesLanguages } from '@/redux/selectors/constantsSelectors';
import { useCallback } from 'react';
import { useAppSelector } from '@/redux/hooks';

type MediaSupportComponent = { type: string; language: string | { name: string; value: string } };

type MediaSupportComponentsProps = {
  data: MediaSupportComponent[];
};

const MediaSupportComponents = ({ data }: MediaSupportComponentsProps) => {
  const Languages = useAppSelector(selectBaseLanguages);
  const SubtitleLanguages = useAppSelector(selectSubtitlesLanguages);

  const langLabel = useCallback(
    (lang: MediaSupportComponent['language']) => {
      if (typeof lang !== 'string') return lang.name;
      return (
        SubtitleLanguages?.find((l) => l.code === lang || l.code === lang.replace('-', '_'))?.label ||
        Languages?.find((l) => l.code === lang || l.code === lang.replace('-', '_'))?.label ||
        lang
      );
    },
    [data]
  );

  return (
    <>
      {data && (
        <Grid container direction="column" rowGap={2}>
          {data.map((v, idx) => (
            <Grid key={`${v.type}-${v.language}`} container justifyContent="space-between" sx={{ mt: idx === 0 ? 1 : 0 }}>
              <Grid item>
                <LabelValue color="primary" label="Type">
                  <Typography>{v.type}</Typography>
                </LabelValue>
              </Grid>
              <Grid item>
                <LabelValue color="primary" label="Language" sx={{ textAlign: 'right' }}>
                  <Typography align="right">{langLabel(v.language)}</Typography>
                </LabelValue>
              </Grid>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

export default MediaSupportComponents;
